

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// APPROVEREFERRALSECTION
// APPROVEREFERRALSECTION


const APPROVEREFERRALSECTION= createAsyncThunk(
  "approveReferralSection/approveReferralSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const approveReferralSectionSlice = createSlice({
  name: "approveReferralSectionSlice",
  initialState: {
    approveReferralSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfapproveReferralSection: (state) => {
        state.approveReferralSection.loading = false
        state.approveReferralSection.error = false
        state.approveReferralSection.data = []
        state.approveReferralSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(APPROVEREFERRALSECTION.fulfilled, (state, action) => {
      state.approveReferralSection = {
        ...state.approveReferralSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEREFERRALSECTION.pending, (state, action) => {
      state.approveReferralSection = {
        ...state.approveReferralSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(APPROVEREFERRALSECTION.rejected, (state, action) => {
      state.approveReferralSection = {
        ...state.approveReferralSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const approveReferralSectionAction = {
    APPROVEREFERRALSECTION,
};

export { approveReferralSectionAction };
export default approveReferralSectionSlice.reducer;
export const {setInitialStateOfapproveReferralSection} = approveReferralSectionSlice.actions
